function modifyCellsCountofAddedOrDeletedRow(store, rowData, isRowAdded = false) {
    try {
      Object.keys(store.duplicateColumnsData).forEach(column => {
        let nodesToBeRefreshed = {'rowNodes': [], 'columns': [], 'force': true};
        if (column !== "themeColor") {
          const columnTypeId = store.duplicateColumnsConfigs[column]?.column_type_id ?? '';
          const columnId = store.isSubsheet ? column + '_' + store.parentRowId : column;
          if (columnTypeId && store.isValidCellValue(columnTypeId, rowData.data[column])) {
            if (isRowAdded) {
              if (!store.duplicateColumnsData[columnId][rowData.data[column]] || store.duplicateColumnsData[columnId][rowData.data[column]] == 0) {
                store.duplicateColumnsData[columnId][rowData.data[column]] = 1;
              } else if (store.duplicateColumnsData[columnId][rowData.data[column]] > 0) {
                store.duplicateColumnsData[columnId][rowData.data[column]] += 1;
              }
            } else {
              if (store.duplicateColumnsData[columnId][rowData.data[column]] && store.duplicateColumnsData[columnId][rowData.data[column]] > 0) {
                store.duplicateColumnsData[columnId][rowData.data[column]] -= 1;
              }
            }
            if (isRowAdded && store.duplicateColumnsData[columnId][rowData.data[column]] == 2) {
              nodesToBeRefreshed['rowNodes'].push(rowData);
              nodesToBeRefreshed['columns'].push(store.duplicateColumnsConfigs[column].alias_path);
              refreshDuplicateCells(store, column, rowData, nodesToBeRefreshed);
            } else if (!isRowAdded && store.duplicateColumnsData[columnId][rowData.data[column]] == 1) {
              nodesToBeRefreshed['columns'].push(store.duplicateColumnsConfigs[column].alias_path);
              refreshDuplicateCells(store, column, rowData, nodesToBeRefreshed);
            }
          }
        }
      });
    } catch (error) {
      console.log('Error: ', error);
    }
  }

function refreshDuplicateCells(store, columnId, rowData, nodesToBeRefreshed) {
    try {
      const firstVisibleRowIndex = store.gridApi?.getFirstDisplayedRow();
      const lastVisibleRowIndex = store.gridApi?.getLastDisplayedRow();
      for (let i = firstVisibleRowIndex; i <= lastVisibleRowIndex; i++) {
        if (i !== rowData.rowIndex) {
          const node = store.gridApi.getDisplayedRowAtIndex(i);
          const nodeValue = node?.data?.[columnId] ?? '';
          const isValueEqual = node?.data && ["5", "17", "22"].includes(store.duplicateColumnsConfigs[columnId]?.column_type_id) ? Number(nodeValue) == Number(rowData.data[columnId]) : nodeValue == rowData.data[columnId];
          if (columnId && node?.data && isValueEqual) {
            nodesToBeRefreshed['rowNodes'].push(node);
            break;
          }
        }
      }
      if (nodesToBeRefreshed['rowNodes'].length > 0) {
        console.log("before refreshCells in refreshDuplicateCells...");
        store.gridApi.refreshCells(nodesToBeRefreshed);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  }

function modifyCellsCountofUpdatedRow(store, rowData, oldRowData) {
    try {
      Object.keys(store.duplicateColumnsData).forEach(columnId => {
        let nodesToBeRefreshed = {'rowNodes': [], 'columns': [], 'force': true};
        if (columnId !== "themeColor") {
          const column = !store.isSubsheet ? columnId : columnId.slice(0, columnId.lastIndexOf('_'));
          const columnTypeId = store.duplicateColumnsConfigs[column]?.column_type_id ?? '';
          let valuesToBeSearched = [];
          nodesToBeRefreshed['columns'].push(store.duplicateColumnsConfigs[column].alias_path);
          if (columnTypeId && store.isValidCellValue(columnTypeId, rowData[column])) {
            if (rowData[column] !== oldRowData.data[column]) {
              if (!store.duplicateColumnsData[columnId][rowData[column]] || store.duplicateColumnsData[columnId][rowData[column]] == 0) {
                store.duplicateColumnsData[columnId][rowData[column]] = 1;
              } else if (store.duplicateColumnsData[columnId][rowData[column]] > 0) {
                store.duplicateColumnsData[columnId][rowData[column]] += 1;
              }
              if (store.duplicateColumnsData[columnId][rowData[column]] == 2) {
                nodesToBeRefreshed['rowNodes'].push(oldRowData);
                valuesToBeSearched.push(rowData[column]);
              }
            }
          }
          if (columnTypeId && store.isValidCellValue(columnTypeId, oldRowData.data[column])) {
            if (rowData[column] !== oldRowData.data[column]) {
              if (store.duplicateColumnsData[columnId][oldRowData.data[column]] && store.duplicateColumnsData[columnId][oldRowData.data[column]] > 0) {
                store.duplicateColumnsData[columnId][oldRowData.data[column]] -= 1;
              }
              if (store.duplicateColumnsData[columnId][oldRowData.data[column]] == 1) {
                valuesToBeSearched.push(oldRowData.data[column]);
              }
            }
          }
          const searchCount = valuesToBeSearched.length;
          if (searchCount > 0) {
            const firstVisibleRowIndex = store.gridApi?.getFirstDisplayedRow();
            const lastVisibleRowIndex = store.gridApi?.getLastDisplayedRow();
            let shouldBreak = 0;
            for (let i = firstVisibleRowIndex; i <= lastVisibleRowIndex; i++) {
              if (shouldBreak == searchCount) {
                break
              };
              if (i !== oldRowData.rowIndex) {
                const node = store.gridApi.getDisplayedRowAtIndex(i);
                const nodeValue = node?.data[column] ?? '';
                const isValue1Equal = node?.data && ["5", "17", "22"].includes(store.duplicateColumnsConfigs[column]?.column_type_id) ? Number(nodeValue) == Number(valuesToBeSearched[0]) : nodeValue == valuesToBeSearched[0];
                if (column && node?.data && isValue1Equal) {
                  nodesToBeRefreshed['rowNodes'].push(node);
                  shouldBreak += 1;
                }
                if (searchCount == 2) {
                  const isValue2Equal = node?.data && ["5", "17", "22"].includes(store.duplicateColumnsConfigs[column]?.column_type_id) ? Number(nodeValue) == Number(valuesToBeSearched[1]) : nodeValue == valuesToBeSearched[1];
                  if (column && node?.data && isValue2Equal) {
                    if (!isValue1Equal) {
                      nodesToBeRefreshed['rowNodes'].push(node);
                    }
                    shouldBreak += 1;
                  }
                }
              }
            }
          }
          if (nodesToBeRefreshed['rowNodes'].length > 0) {
        console.log("before refreshCells in modifyCellsCountofUpdatedRow...");
            store.gridApi.refreshCells(nodesToBeRefreshed);
          }
        }
      });
    } catch (error) {
      console.log('Error: ', error);
    }
}

export function modifyHighlightedCellsCountDuringSocketUpdation(store, rowData, oldRowData = {}, isNewRow = false, isRowDeleted = false) {
    try {
        if (isNewRow) {
            modifyCellsCountofAddedOrDeletedRow(store, rowData, true);
        } else if (isRowDeleted) {
            modifyCellsCountofAddedOrDeletedRow(store, rowData);
        } else {
            modifyCellsCountofUpdatedRow(store, rowData, oldRowData);
        }
    } catch (error) {
        console.log('Error: ', error);
    }
}